import { render, staticRenderFns } from "./SingleNewsDisplay.vue?vue&type=template&id=8e322286&"
import script from "./SingleNewsDisplay.vue?vue&type=script&lang=js&"
export * from "./SingleNewsDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports